import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DomSanitizer } from '@angular/platform-browser';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { sidebarIcons } from 'app/core/constants/icons';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [
        FuseVerticalNavigationComponent,
        MatIconModule,
        MatProgressBarModule,
    ],
    templateUrl: './sidebar.component.html',
    // styleUrl: './sidebar.component.scss',
    styles: [
        `
            demo-sidebar
                fuse-vertical-navigation
                .fuse-vertical-navigation-wrapper {
                box-shadow: none !important;
            }
        `,
    ],
})
export class SidebarComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @Input() sidebarData!: FuseNavigationItem[];

    navigationAppearance: 'default' | 'dense' = 'dense';
    isScreenSmall: boolean;

    iconsUrl = 'icons/sho/round-stroke';
    isIcon: boolean = false;
    SideBarIconNames = sidebarIcons;

    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _maIconRegistry: MatIconRegistry,
        private _domSanitizer: DomSanitizer
    ) {}

    // ----------------------------------------------------------------------
    // @ Lifecycle hooks
    // ----------------------------------------------------------------------

    ngOnInit(): void {
        // Registering Icons
        this.isIcon = this._maIconRegistry.addSvgIcon(
            'joker',
            this._domSanitizer.bypassSecurityTrustResourceUrl(
                `${this.iconsUrl}/joker.svg`
            )
        )
            ? true
            : false;

        for (let index = 0; index < this.SideBarIconNames.length; index++) {
            const iconName = this.SideBarIconNames[index];

            this._maIconRegistry.addSvgIcon(
                iconName,
                this._domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconsUrl}/${iconName}.svg`
                )
            );
        }

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('xl');

                // Change the navigation appearance
                this.navigationAppearance = this.isScreenSmall
                    ? 'dense'
                    : 'default';
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
